import Factory from "@/schemas/factory";

const schema = new Factory()
    .hasId()
    .translatable()
    .sluggable()
    .hasTitle()
    .hasSummary()
    .hasImage()
	.hasBulletSummary()
	.hasLede()
    .hasBody()
    .hasMetadata()
    .publishable()
    .publishableByDate()
	.hasLotusNotesId()
    .hasTimestamps()
    .make();

schema.prop('collectionId').setType(Number).addMetadata('mergeable', true).addMetadata('draftable', true);
schema.prop('programmeAreaId').setType(Number).setValue(null).addMetadata('mergeable', true).addMetadata('draftable', true);
schema.prop('projectId').setType(Number).setValue(null).addMetadata('mergeable', true).addMetadata('draftable', true);
schema.prop('eventId').setType(Number).setValue(null).addMetadata('mergeable', true).addMetadata('draftable', true);
schema.prop('externalAuthors').setType(String).addMetadata('translatable', true).addMetadata('draftable', true);
schema.prop('outreach').setType(Boolean).setValue(false).addMetadata('translatable', true).addMetadata('draftable', true);

export default schema;
